(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

/* ============================
   1) Helpers globales de foco
   ============================ */
if (typeof trapFocus === 'undefined') {
  var trapFocusHandlers = {};

  var trapFocus = function (container, elementToFocus) {
    if (!container) return;

    var focusableSelectors =
      'a[href], area[href], input:not([disabled]), select:not([disabled]), ' +
      'textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex^="-"])';

    var focusableElements = Array.prototype.slice.call(
      container.querySelectorAll(focusableSelectors)
    );

    if (!elementToFocus) {
      elementToFocus = focusableElements[0] || container;
    }

    trapFocusHandlers.keydown = function (event) {
      if (event.key !== 'Tab') return;

      var first = focusableElements[0];
      var last = focusableElements[focusableElements.length - 1];

      if (!first || !last) return;

      if (event.shiftKey) {
        // Shift + Tab
        if (document.activeElement === first || document.activeElement === container) {
          event.preventDefault();
          last.focus();
        }
      } else {
        // Tab normal
        if (document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    };

    trapFocusHandlers.focusin = function (event) {
      if (!container.contains(event.target)) {
        elementToFocus.focus();
      }
    };

    document.addEventListener('keydown', trapFocusHandlers.keydown);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
  };

  var removeTrapFocus = function (elementToFocus) {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    document.removeEventListener('focusin', trapFocusHandlers.focusin);

    if (elementToFocus && typeof elementToFocus.focus === 'function') {
      elementToFocus.focus();
    }
  };
}

/* ============================
   2) Contador del carrito
   ============================ */
document.addEventListener('DOMContentLoaded', function () {
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var countElement = document.querySelector('[data-cart-count]');
        var bubble = document.querySelector('.cart-count-bubble');

        if (!countElement || !bubble) return;

        countElement.textContent = cart.item_count;

        if (cart.item_count > 0) {
          bubble.style.display = 'flex';
        } else {
          setTimeout(function () {
            bubble.style.display = 'none';
            countElement.textContent = '';
          }, 100);
        }
      })
      .catch(function (error) {
        console.error('Error updating cart count:', error);
      });
  }

  var cartEvents = [
    'ajaxCart:added',
    'ajaxCart:updated',
    'ajaxCart:removed',
    'cart:updated',
    'cart:change'
  ];

  cartEvents.forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      setTimeout(updateCartCount, 300);
    });
  });

  document.body.addEventListener('click', function (e) {
    if (
      e.target.closest('.cart-remove-button') ||
      e.target.closest('[data-ajax-cart-command="remove"]')
    ) {
      setTimeout(updateCartCount, 500);
    }
  });

  setInterval(updateCartCount, 3000);
});

/* =========================================================
   3) HOTFIX SUBMENUS (MORE) - no redefine custom elements
   ========================================================= */
(function () {
  const KEY = '__MD_SUBMENU_HOTFIX_V1__';
  if (window[KEY]) return;
  window[KEY] = true;

  const now = () => (typeof performance !== 'undefined' ? performance.now() : Date.now());

  function initOne(drawerEl) {
    // El root <details> (hamburguesa)
    const rootDetails = drawerEl.querySelector('#Details-menu-drawer-container');
    if (!rootDetails) return;

    // Para bloquear cierres por focusout/blur durante el click
    let ignoreFocusOutUntil = 0;

    // 1) Evitar que el theme cierre el drawer por focusout en el momento del click
    drawerEl.addEventListener(
      'focusout',
      (e) => {
        if (now() < ignoreFocusOutUntil) {
          e.stopImmediatePropagation();
          e.stopPropagation();
        }
      },
      true // capture
    );

    // 2) Interceptar clicks en summaries de submenus (como MORE) ANTES que el theme
    drawerEl.addEventListener(
      'click',
      (e) => {
        const summary = e.target.closest('summary');
        if (!summary || !drawerEl.contains(summary)) return;

        const details = summary.parentElement;
        if (!details || details.tagName !== 'DETAILS') return;

        // Si es el summary principal (hamburguesa), no lo tocamos
        if (details === rootDetails) return;

        // Es un submenu summary -> lo manejamos nosotros
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        // Mantener drawer abierto sí o sí
        if (!rootDetails.hasAttribute('open')) rootDetails.setAttribute('open', '');

        // Bloquear cierres por blur/focusout por un instante
        ignoreFocusOutUntil = now() + 900;

        const isOpen = details.hasAttribute('open');

        // (Opcional) cerrar otros submenus abiertos del mismo nivel
        const siblingsOpen = Array.from(
          details.parentElement.querySelectorAll(':scope > details[open]')
        );
        siblingsOpen.forEach((d) => {
          if (d !== details) {
            d.removeAttribute('open');
            d.classList.remove('menu-opening');
            const s = d.querySelector(':scope > summary');
            if (s) s.setAttribute('aria-expanded', 'false');
          }
        });

        if (isOpen) {
          // Cerrar submenu
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
          summary.setAttribute('aria-expanded', 'false');

          // Sacar estado visual si tu CSS lo usa
          const container = details.closest('.has-submenu');
          if (container) container.classList.remove('submenu-open');

          // Devolver foco
          try { summary.focus({ preventScroll: true }); } catch (_) { summary.focus(); }
          return;
        }

        // Abrir submenu
        details.setAttribute('open', '');
        details.classList.add('menu-opening');
        summary.setAttribute('aria-expanded', 'true');

        const container = details.closest('.has-submenu');
        if (container) container.classList.add('submenu-open');

        const submenu = summary.nextElementSibling;
        const closeBtn = details.querySelector('button.menu-drawer__close-button');

        // Asegurar type button (doble safety)
        if (closeBtn && !closeBtn.hasAttribute('type')) closeBtn.setAttribute('type', 'button');

        // Foco adentro para que el theme no “piense” que salimos del drawer
        setTimeout(() => {
          const focusTarget = closeBtn || submenu || summary;
          if (focusTarget && typeof focusTarget.focus === 'function') {
            try { focusTarget.focus({ preventScroll: true }); } catch (_) { focusTarget.focus(); }
          }
        }, 0);
      },
      true // capture
    );

    // 3) Interceptar botones "Back" (close-button) en capture
    drawerEl.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest('button.menu-drawer__close-button');
        if (!btn || !drawerEl.contains(btn)) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        ignoreFocusOutUntil = now() + 700;

        const details = btn.closest('details');
        if (!details || details === rootDetails) return;

        const summary = details.querySelector(':scope > summary');
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        if (summary) summary.setAttribute('aria-expanded', 'false');

        const container = details.closest('.has-submenu');
        if (container) container.classList.remove('submenu-open');

        if (summary) {
          try { summary.focus({ preventScroll: true }); } catch (_) { summary.focus(); }
        }
      },
      true // capture
    );
  }

  function initAll() {
    document.querySelectorAll('header-drawer').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();


customElements.define('sticky-header', StickyHeader);


(function () {
  const el = document.getElementById('Details-menu-drawer-container');
  if (!el) return;

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'open') {
        if (!el.hasAttribute('open')) {
          console.log('[TRACE] Se cerró el drawer (open removido)');
          console.trace('[TRACE STACK] Quién lo cerró:');
        }
      }
    }
  });

  obs.observe(el, { attributes: true });
})();




  } catch(e) { console.error(e); }
})();
})();
